import { ll } from "../core/ll";

var maskId = 0;

$.fn.extend({
    mask: function (args) {
        args = args || {};
        var elem = this.filter(":not(.pane-field-number)"),
            id = "Mask" + (maskId++),
            overlayMargin = args.overlayMargin || "0",
            marginTop = args.marginTop || "10px",
            height = args.height || "100%",
            loadingText = args.loadingText || "",
            loadingMaskHtml = '<div id="' + id + '" class="k-loading-mask z-loading" style="height: ' + height + "; margin-top: " + overlayMargin + ';">' +
                                    '<div class="k-loading-image_2x" style="margin-top: ' + marginTop + ';"></div>' +
                                    '<span class="z-loading-text">' + loadingText + "</span>" +
                                    '<div class="z-loading-text z-still-loading">' + ll("StillLoading") + "</div>" +
                                "</div>";

        if (args.inputMask) {
            loadingMaskHtml = '<div id="' + id + '" class="z-input-mask z-loading">' +
                                    '<div class="app-small-spinner right" style="margin-top: 4px;"></div>' +
                                    '<span class="z-loading-text">' + loadingText + "</span>" +
                                "</div>";
        }

        if (elem.hasClass("js-loading")) {
            return this;
        }

        elem.addClass("js-loading");

        $.wait(5000).then(function () {
            $("#" + id).find(".z-still-loading").show();
        });

        elem.append(loadingMaskHtml);
        if (!args.inputMask) {
            elem.css("overflow", "hidden");
        }
        return this;
    },
    unmask: function () {
        this.removeClass("js-loading");
        this.find(".z-loading").remove();
        this.filter(":not(.pane-field-number)").css("overflow", "");
        return this;
    }
});
